/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ProblemDetails,
  PuntoDiRaccoltaCreateDTO,
  PuntoDiRaccoltaDTO,
  PuntoDiRaccoltaUpdateDTO,
} from '../models/index';
import {
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    PuntoDiRaccoltaCreateDTOFromJSON,
    PuntoDiRaccoltaCreateDTOToJSON,
    PuntoDiRaccoltaDTOFromJSON,
    PuntoDiRaccoltaDTOToJSON,
    PuntoDiRaccoltaUpdateDTOFromJSON,
    PuntoDiRaccoltaUpdateDTOToJSON,
} from '../models/index';

export interface DeletePuntoDiRaccoltaRequest {
    puntoDiRaccoltaId: string;
    tenantId: string;
}

export interface GetPuntiDiRaccoltaRequest {
    tenantId: string;
}

export interface GetPuntoDiRaccoltaByIdRequest {
    puntoDiRaccoltaId: string;
    tenantId: string;
}

export interface GetPuntoDiRaccoltaDefaultRequest {
    tenantId: string;
}

export interface InsertPuntoDiRaccoltaRequest {
    tenantId: string;
    puntoDiRaccoltaCreateDTO?: PuntoDiRaccoltaCreateDTO;
}

export interface UpdatePuntoDiRaccoltaRequest {
    puntoDiRaccoltaId: string;
    tenantId: string;
    puntoDiRaccoltaUpdateDTO?: PuntoDiRaccoltaUpdateDTO;
}

/**
 * 
 */
export class PuntiDiRaccoltaApi extends runtime.BaseAPI {

    /**
     */
    async deletePuntoDiRaccoltaRaw(requestParameters: DeletePuntoDiRaccoltaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['puntoDiRaccoltaId'] == null) {
            throw new runtime.RequiredError(
                'puntoDiRaccoltaId',
                'Required parameter "puntoDiRaccoltaId" was null or undefined when calling deletePuntoDiRaccolta().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling deletePuntoDiRaccolta().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/PuntiDiRaccolta/{puntoDiRaccoltaId}`.replace(`{${"puntoDiRaccoltaId"}}`, encodeURIComponent(String(requestParameters['puntoDiRaccoltaId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deletePuntoDiRaccolta(requestParameters: DeletePuntoDiRaccoltaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePuntoDiRaccoltaRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getPuntiDiRaccoltaRaw(requestParameters: GetPuntiDiRaccoltaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PuntoDiRaccoltaDTO>>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getPuntiDiRaccolta().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/PuntiDiRaccolta`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PuntoDiRaccoltaDTOFromJSON));
    }

    /**
     */
    async getPuntiDiRaccolta(requestParameters: GetPuntiDiRaccoltaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PuntoDiRaccoltaDTO>> {
        const response = await this.getPuntiDiRaccoltaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPuntoDiRaccoltaByIdRaw(requestParameters: GetPuntoDiRaccoltaByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PuntoDiRaccoltaDTO>> {
        if (requestParameters['puntoDiRaccoltaId'] == null) {
            throw new runtime.RequiredError(
                'puntoDiRaccoltaId',
                'Required parameter "puntoDiRaccoltaId" was null or undefined when calling getPuntoDiRaccoltaById().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getPuntoDiRaccoltaById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/PuntiDiRaccolta/{puntoDiRaccoltaId}`.replace(`{${"puntoDiRaccoltaId"}}`, encodeURIComponent(String(requestParameters['puntoDiRaccoltaId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PuntoDiRaccoltaDTOFromJSON(jsonValue));
    }

    /**
     */
    async getPuntoDiRaccoltaById(requestParameters: GetPuntoDiRaccoltaByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PuntoDiRaccoltaDTO> {
        const response = await this.getPuntoDiRaccoltaByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPuntoDiRaccoltaDefaultRaw(requestParameters: GetPuntoDiRaccoltaDefaultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PuntoDiRaccoltaCreateDTO>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getPuntoDiRaccoltaDefault().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/PuntiDiRaccolta/default`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PuntoDiRaccoltaCreateDTOFromJSON(jsonValue));
    }

    /**
     */
    async getPuntoDiRaccoltaDefault(requestParameters: GetPuntoDiRaccoltaDefaultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PuntoDiRaccoltaCreateDTO> {
        const response = await this.getPuntoDiRaccoltaDefaultRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async insertPuntoDiRaccoltaRaw(requestParameters: InsertPuntoDiRaccoltaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PuntoDiRaccoltaDTO>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling insertPuntoDiRaccolta().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/PuntiDiRaccolta`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PuntoDiRaccoltaCreateDTOToJSON(requestParameters['puntoDiRaccoltaCreateDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PuntoDiRaccoltaDTOFromJSON(jsonValue));
    }

    /**
     */
    async insertPuntoDiRaccolta(requestParameters: InsertPuntoDiRaccoltaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PuntoDiRaccoltaDTO> {
        const response = await this.insertPuntoDiRaccoltaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updatePuntoDiRaccoltaRaw(requestParameters: UpdatePuntoDiRaccoltaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['puntoDiRaccoltaId'] == null) {
            throw new runtime.RequiredError(
                'puntoDiRaccoltaId',
                'Required parameter "puntoDiRaccoltaId" was null or undefined when calling updatePuntoDiRaccolta().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling updatePuntoDiRaccolta().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/PuntiDiRaccolta/{puntoDiRaccoltaId}`.replace(`{${"puntoDiRaccoltaId"}}`, encodeURIComponent(String(requestParameters['puntoDiRaccoltaId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PuntoDiRaccoltaUpdateDTOToJSON(requestParameters['puntoDiRaccoltaUpdateDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updatePuntoDiRaccolta(requestParameters: UpdatePuntoDiRaccoltaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updatePuntoDiRaccoltaRaw(requestParameters, initOverrides);
    }

}
